export default __webpack_public_path__ + "static/AQP_PAConstitution_SocialMedia-085082057fb809bade55d498e54b7fa0.png";